import React, { useEffect, useRef } from "react";
import { Form, Segment } from "semantic-ui-react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";
import "react-datepicker/dist/react-datepicker.css";
import { getTimeZoneLabel } from "../../utilities/dateTime";

const toDisplayDate = (date, timeZone) => {
  if (!date || !timeZone) return date;
  const zoned = moment.tz(date, timeZone);
  return new Date(
    zoned.year(),
    zoned.month(),
    zoned.date(),
    zoned.hours(),
    zoned.minutes(),
    zoned.seconds()
  );
};

const fromDisplayDate = (displayDate, timeZone) => {
  if (!displayDate || !timeZone) return displayDate;
  return moment
    .tz(
      {
        year: displayDate.getFullYear(),
        month: displayDate.getMonth(),
        day: displayDate.getDate(),
        hour: displayDate.getHours(),
        minute: displayDate.getMinutes(),
        second: displayDate.getSeconds(),
      },
      timeZone
    )
    .toDate();
};

const PreSchedule = ({ selectedDate, setDate, required, timeZone }) => {
  const prevTimeZoneRef = useRef(timeZone);

  useEffect(() => {
    const prevTimeZone = prevTimeZoneRef.current;
    prevTimeZoneRef.current = timeZone;

    if (!selectedDate || !timeZone || !prevTimeZone || prevTimeZone === timeZone) {
      return;
    }

    const reanchoredDate = fromDisplayDate(
      toDisplayDate(selectedDate, prevTimeZone),
      timeZone
    );

    setDate(reanchoredDate);
  }, [timeZone]);

  const handleChange = (date) => {
    const actualDate = timeZone ? fromDisplayDate(date, timeZone) : date;
    setDate(actualDate);
  };

  const displaySelected = timeZone
    ? toDisplayDate(selectedDate, timeZone)
    : selectedDate;

  const timeZoneLabel = getTimeZoneLabel(timeZone);

  return (
    <Form className="delivery-options-outer" style={{ marginBottom: 24 }}>
      <Segment>
        <Form.Field>
          <div className="ui header">
            {" "}
            Order scheduled date
            {required && <strong className="required-red"> *</strong>}
          </div>
          <label>If the order has already been scheduled, please enter the time here.</label>
        </Form.Field>
        <DatePicker
          selected={displaySelected}
          onChange={handleChange}
          showTimeSelect
          dateFormat="MMMM d, yyyy h:mm aa"
        />
        {timeZoneLabel && (
          <div className="preschedule-timezone-label">
            Times shown in {timeZoneLabel}
          </div>
        )}
      </Segment>
    </Form>
  );
};

PreSchedule.propTypes = {
  selectedDate: PropTypes.any,
  setDate: PropTypes.func,
  required: PropTypes.bool,
  timeZone: PropTypes.string,
};

export default PreSchedule;
